/* eslint-disable react/style-prop-object */
import React, { ReactElement } from "react";
import { FormattedMessage, FormattedNumber } from "react-intl";
import { useSelector } from "react-redux";

import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import IconSelector from "components/shared/images/IconSelector";

import { getServerDetails } from "redux/selectors/serversSelector";

const ClusterRecap = ({
 server_name,
 type
}: {
 server_name: string;
 type: string;
}): ReactElement => {
 const server = useSelector(getServerDetails);

 return (
  <Paper
   elevation={1}
   sx={{
    p: 2,
    maxHeight: 580,
    position: "sticky",
    borderRadius: "5px"
   }}>
   <Stack mb={2} alignItems="center" direction="row" spacing={1}>
    <IconSelector icon={"ClusterIcon"} props={{ fontSize: "large", color: "kxOrange" }} />
    <Typography variant="unboundedTitle" fontWeight="bold" fontSize={18}>
     <FormattedMessage id="cluster.add.recap" />
    </Typography>
   </Stack>
   <Divider sx={{ my: 1 }} />
   <Stack textAlign="left" mb={1}>
    <Typography variant="unboundedTitle" fontSize={14}>
     <FormattedMessage id="cluster.add.serverData" />
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={120} textAlign="start" fontWeight="bold">
     <FormattedMessage id={type === "db" ? "cluster.add.serverDbName" : "cluster.add.serverName"} />
     :
    </Typography>
    <Typography variant="subtitle2" noWrap>
     {server_name}
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={120} textAlign="start" fontWeight="bold">
     <FormattedMessage id="cluster.add.serverType" />:
    </Typography>
    <Typography variant="subtitle2" noWrap>
     {server.server_type}
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={120} textAlign="start" fontWeight="bold">
     <FormattedMessage id="cluster.add.serverManageType" />:
    </Typography>
    <Typography variant="subtitle2" noWrap>
     {server.type}
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={120} textAlign="start" fontWeight="bold">
     <FormattedMessage id="cluster.add.serverPrice" />:
    </Typography>
    <Typography variant="subtitle2">
     <FormattedNumber value={server.price} style={"currency"} currency="EUR" />
    </Typography>
   </Stack>
  </Paper>
 );
};

export default ClusterRecap;
